// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"3d2fcdb2","442":"e6074c8f"}[chunkId] + ".chunk.css";
};